import FuxHTTP from "../../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../../APIConfig";
import AuthAPI from "../../AuthAPI";

export const _Events = {
    pagination: cursor => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url(`/user/module-events/pagination`),
            {
                token: AuthAPI.getUserAccessToken(),
                cursor: cursor,
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    getFullUserEventInfo: (event_id) => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url(`/user/module-events/event/full-info`),
            {
                token: AuthAPI.getUserAccessToken(),
                event_id: event_id
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    getUserEventStatistics: (event_id) => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url(`/user/module-events/event/statistics`),
            {
                token: AuthAPI.getUserAccessToken(),
                event_id: event_id
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    delete: (event_id) => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url(`/user/module-events/event/delete`),
            {
                token: AuthAPI.getUserAccessToken(),
                event_id: event_id,
            },
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    save: event => {
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url(`/user/module-events/event/save`),
            event,
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    }
}